import type { QueryClient } from "@tanstack/react-query";

export function clearPatientPaymentSession(client: QueryClient) {
  // Browser capability and public price quotes do not belong to a patient. Preserve only these
  // across sign-in; customer sessions, saved cards, orders and all other queries must be cleared.
  client.removeQueries({
    predicate: ({ queryKey: [key] }) =>
      key !== "wallet-availability" && key !== "stripe-affirm-messaging",
  });
  client.getMutationCache().clear();
}
